import actions from './actions';
import mutations from './mutations';
import sessionManager from './sessionManager';

const state = {
    idpUri: '',
    redirectUri: '',
    fqdn: '',
    subdomain: '',
    // CSAdmin = 4, GroupAdmin = 3, ClientAdmin = 2, ClientUser = 1, NotAuthenticated = 0
    role: 0,
    tokenExpiry: 0,
    interruptRefreshToken: false,
    refreshToken: false,
    siteType: 0,
};

// The following defines the permissions table, with the name representing the function
// the number representing the site type
// the array collection representing the permitted permissions
const allAccessTable = {
    onoffaccessTable: {
        1: [4, 3, 2],
        2: [4, 3], // Remove this line to lock down on/off for group children sites
        3: [4, 3]
    },
    onoffmessageaccessTable: {
        // 2: [4, 3, 2] // Enable this line to lock down on/off for group children sites
        2: [2]
    },
    singlecontexteditTable: {
        1: [4, 3, 2],
        2: [4, 3, 2],
        3: [4, 3]
    },
    contextviewaccessTable: {
        1: [4, 3, 2],
        2: [4, 3, 2],
        3: [4, 3]
    },
    processupdatesaccessTable: {
        1: [4, 3, 2],
        2: [4, 3, 2],
        3: [4, 3]
    },
    groupAdminViewTable: {
        3: [4, 3]
    }
};

const getters = {
//    isAuthenticated: state => state.role > 0,
//  Check if tokenExpiry is more than 10 minutes away
    isAuthenticated: state => () => {
        return (state.tokenExpiry - new Date().getTime()
            > sessionManager.tokenExpiryMS()) &&
            state.role > 0;
    },
    isUserValid: state => state.role > 0,
    authorizationUri: (state) => {
        const queryParams = `client_id=quicklinks&redirect_uri=${encodeURIComponent(state.redirectUri)}&response_type=token&state=`;
        return `https://${state.idpUri}/oauth2/authorize?${queryParams}`;
    },
    authorizationUriComplispaceStaff: (state) => {
        const queryParams = `client_id=quicklinks&redirect_uri=${encodeURIComponent(state.redirectUri)}&scope=staff.complispace&response_type=token&state=`;
        return `https://${state.idpUri}/oauth2/authorize?${queryParams}`;
    },
    role: state => state.role,
    isAllowedTo: state => minRole => state.role >= minRole,
    refreshToken: state => state.refreshToken,
    hasAccess: state => (accessTableName) => {
        const accessTable = allAccessTable[accessTableName];
        return accessTable[state.siteType] ?
            accessTable[state.siteType].indexOf(parseInt(state.role, 10)) >= 0 :
            false;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/session/store.js